var _excluded = ["analyticsName", "onClick", "href"];

function cov_1ucoak1x8() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/EventCard/ClickableCardWithMetrics.tsx";
  var hash = "3b9a2bf145fb532cefe4798d2a84ddfce94db283";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/EventCard/ClickableCardWithMetrics.tsx",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 81
        },
        end: {
          line: 56,
          column: 1
        }
      },
      "1": {
        start: {
          line: 19,
          column: 25
        },
        end: {
          line: 19,
          column: 43
        }
      },
      "2": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 43,
          column: 3
        }
      },
      "3": {
        start: {
          line: 27,
          column: 67
        },
        end: {
          line: 30,
          column: 5
        }
      },
      "4": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 28,
          column: 41
        }
      },
      "5": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 17
        }
      },
      "6": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 42,
          column: 6
        }
      },
      "7": {
        start: {
          line: 44,
          column: 2
        },
        end: {
          line: 55,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 13,
            column: 81
          },
          end: {
            line: 13,
            column: 82
          }
        },
        loc: {
          start: {
            line: 18,
            column: 6
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 18
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 27,
            column: 67
          },
          end: {
            line: 27,
            column: 68
          }
        },
        loc: {
          start: {
            line: 27,
            column: 74
          },
          end: {
            line: 30,
            column: 5
          }
        },
        line: 27
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 43,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 43,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 26
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3b9a2bf145fb532cefe4798d2a84ddfce94db283"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ucoak1x8 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1ucoak1x8();

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Button, Card, Link } from '@opendoor/bricks/core';
import { useObservability } from '@opendoor/observability';
cov_1ucoak1x8().s[0]++;

/** Renders a clickable card and automatically tracks clicks */
export var ClickableCardWithMetrics = function ClickableCardWithMetrics(_ref) {
  var analyticsName = _ref.analyticsName,
      onClick = _ref.onClick,
      href = _ref.href,
      props = _objectWithoutProperties(_ref, _excluded);

  cov_1ucoak1x8().f[0]++;

  var _ref2 = (cov_1ucoak1x8().s[1]++, useObservability()),
      trackEvent = _ref2.trackEvent;
  /**
   * Automatically tracks each click
   * Note: Button also tracks click but we weren't wrapping in a button
   * when this component was first used, so leaving double tracking to
   * preserve analytics continuity
   */


  cov_1ucoak1x8().s[2]++;

  if (onClick) {
    cov_1ucoak1x8().b[0][0]++;
    cov_1ucoak1x8().s[3]++;

    var clickHandler = function clickHandler(e) {
      cov_1ucoak1x8().f[1]++;
      cov_1ucoak1x8().s[4]++;
      trackEvent('click', analyticsName);
      cov_1ucoak1x8().s[5]++;
      onClick(e);
    };

    cov_1ucoak1x8().s[6]++;
    return /*#__PURE__*/React.createElement(Button, {
      variant: "ghost",
      onClick: clickHandler,
      analyticsName: analyticsName,
      "aria-label": analyticsName,
      type: "button",
      width: "100%"
    }, /*#__PURE__*/React.createElement(Card, _extends({}, props, {
      id: analyticsName
    })));
  } else {
    cov_1ucoak1x8().b[0][1]++;
  }

  cov_1ucoak1x8().s[7]++;
  return /*#__PURE__*/React.createElement(Link, {
    href: href,
    analyticsName: analyticsName,
    "aria-label": analyticsName,
    width: "100%"
  }, /*#__PURE__*/React.createElement(Card, _extends({}, props, {
    id: analyticsName,
    _hover: {
      color: 'neutrals100',
      backgroundColor: 'neutrals30'
    }
  })));
};